import classNames from 'classnames'
import React from 'react'

type NavigableSectionProps = {
  id: string
  isFirst?: boolean // True for the first block in the page (for proper top margin)
  componentTypeForCSS?: 'agenda' | 'logos' // Solo para casos específicos que necesitan CSS especial
  children: React.ReactNode
  className?: string // Para modificadores contextuales
}

/**
 * Wrapper component for sections that appear in navigation menus.
 * Simplified with contextual spacing for background combinations.
 */
const NavigableSection: React.FC<NavigableSectionProps> = ({
  id,
  isFirst = false,
  componentTypeForCSS,
  children,
  className
}) => {
  const sectionClassName = classNames(
    'section-scroll',
    'navigable-component',
    {
      'first-navigable-section': isFirst
    },
    className // Contextual modifiers
  )

  const dataAttributes = componentTypeForCSS
    ? { 'data-component': componentTypeForCSS }
    : {}

  return (
    <section className={sectionClassName} {...dataAttributes}>
      <a id={id} href={`#${id}`} aria-label={`Navigate to ${id} section`} />
      {children}
    </section>
  )
}

export default NavigableSection
